export const typography = {
  h1: { fontSize: "7.2rem", fontWeight: "bold", lineHeight: "8rem" },
  h2: { fontSize: "5.6rem", fontWeight: "bold", lineHeight: "6.4rem" },
  h3: { fontSize: "4.8rem", fontWeight: "bold", lineHeight: "5.6rem" },
  h4: { fontSize: "4.0rem", fontWeight: "bold", lineHeight: "4.8rem" },
  h5: { fontSize: "3.2rem", fontWeight: "bold", lineHeight: "4rem" },
  h6: { fontSize: "2.4rem", fontWeight: "bold", lineHeight: "3.2rem" },
  h7: { fontSize: "1.6rem", fontWeight: "bold", lineHeight: "2.4rem" },
  fonts: {
    primary: '"Roboto"',
  },
  weights: {
    regular: 400,
    medium: 500,
    bold: 700,
  },
  sizes: {
    xxl: { fontSize: "2.4rem", lineHeight: "3.2rem" },
    xl: { fontSize: "2.0rem", lineHeight: "2.8rem" },
    lg: { fontSize: "1.8rem", lineHeight: "2.4rem" },
    md: { fontSize: "1.6rem", lineHeight: "2.4rem" },
    sm: { fontSize: "1.4rem", lineHeight: "2rem" },
    xs: { fontSize: "1.2rem", lineHeight: "1.6rem" },
    xxs: { fontSize: "1.0rem", lineHeight: "1.4rem" },
  },
};
